import React, { useRef, useEffect, useState } from 'react';
import { useFontLoader } from '../../../../dummies/RichTextEditor/useFontLoader';
import { heritageColors } from '../../../../heritageTheme.ts';

const Minimal = ({ data = { notices: [] }, title = 'לוח מודעות', showTitle = true }) => {
  const contentRef = useRef(null);
  const containerRef = useRef(null);
  const firstSetRef = useRef(null);
  const [needsScroll, setNeedsScroll] = useState(false);
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 60_000);
    return () => clearInterval(id);
  }, []);

  const activeNotices = (data.notices || []).filter(
    n => !n.expiryDate || new Date(n.expiryDate) > now
  );

  const allNoticesHtml = activeNotices.map(n => n.content).join(' ') || '';
  useFontLoader(allNoticesHtml);

  useEffect(() => {
    const checkScroll = () => {
      if (!containerRef.current || !firstSetRef.current || activeNotices.length === 0) return;
      const containerHeight = containerRef.current.clientHeight;
      const contentHeight = firstSetRef.current.offsetHeight;
      setNeedsScroll(containerHeight > 0 && contentHeight > containerHeight + 2);
    };
    const timer = setTimeout(checkScroll, 100);
    const resizeObserver = new ResizeObserver(checkScroll);
    if (containerRef.current) resizeObserver.observe(containerRef.current);
    return () => { clearTimeout(timer); resizeObserver.disconnect(); };
  }, [activeNotices]);

  const accentColor = heritageColors.gold || '#D4AF37';
  const navyColor = heritageColors.navy || '#1a3a5c';
  const borderColor = heritageColors.border || '#D7CCC8';

  const renderItems = (notices, keyPrefix = '') =>
    notices.map((notice) => (
      <li
        key={`${keyPrefix}${notice.id}`}
        data-notice-item
        style={{
          borderTop: `2px solid ${accentColor}`,
          padding: '0.55em 0 0.65em',
          borderBottom: `1px solid ${borderColor}`,
          width: '100%',
        }}
      >
        <div
          style={{ fontSize: '0.78em', color: navyColor, lineHeight: 1.55, width: '100%' }}
          dangerouslySetInnerHTML={{ __html: notice.content }}
        />
      </li>
    ));

  return (
    <div style={{
      padding: '20px',
      direction: 'rtl',
      height: '100%',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      fontSize: 'inherit',
      boxSizing: 'border-box',
    }}>
      {showTitle && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          borderBottom: `2px solid ${navyColor}`,
          paddingBottom: '8px',
          marginBottom: '4px',
        }}>
          <span className="material-symbols-outlined" style={{ color: navyColor, fontSize: '1.1em' }}>campaign</span>
          <h3 style={{ margin: 0, fontWeight: 'bold', color: navyColor, fontSize: '0.875em' }}>{title}</h3>
        </div>
      )}

      {activeNotices.length === 0 ? (
        <p style={{ color: heritageColors.slate || '#795548', fontSize: '0.875em', marginTop: '12px' }}>אין מודעות להצגה</p>
      ) : (
        <div ref={containerRef} style={{ overflow: 'hidden', flex: 1, position: 'relative' }}>
          {needsScroll && (
            <style>{`
              @keyframes scrollNoticesMinimal {
                0% { transform: translateY(0); }
                100% { transform: translateY(calc(-100% / 3)); }
              }
            `}</style>
          )}
          <div ref={contentRef} style={{
            animation: needsScroll ? 'scrollNoticesMinimal 30s linear infinite' : 'none',
          }}>
            <ul ref={firstSetRef} style={{ listStyle: 'none', padding: 0, margin: 0 }}>
              {renderItems(activeNotices)}
            </ul>
            {needsScroll && (
              <>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  {renderItems(activeNotices, 'dup1-')}
                </ul>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                  {renderItems(activeNotices, 'dup2-')}
                </ul>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Minimal;
